import { BehaviorEnum, Properties } from "@/services/posts/types";
import { MediaType } from "@/services/files/types";
import { AllowedPostSettings } from "@/services/channels/types";

export interface FolderPostProperties extends Properties {
    sort: FolderSortTypes,
    behavior: BehaviorEnum,
    showTime: number,
    name: string,
    path: string,
    caption: string
}

export interface FolderPostCSS extends CSS {
    wrapper: string,
    folderItem: string,
    caption: string
}

export interface FolderPost {
    id: string,
    name: string,
    type: MediaType
}
export enum FolderSortTypes {
    shuffle = "shuffle",
    alphanumeric = "alphanumeric"
}

export interface FolderPostSettings extends AllowedPostSettings {
    styleId: string,
    allowCaption: boolean,
}
